import type { NextPage } from 'next'
import image from 'next/image'
import { useRouter } from 'next/navigation'
import ColumnComponent from 'componentsUnits/columnComponent'
import title from 'componentsUnits/title'
import timeAgo from 'helpers/timeAgo'
import styles from './UserInfomationHeader.module.scss'
import { useAppDispatch, useAppSelector } from 'reducers/storeHooks'
import { Size } from 'types/size'

interface Props {
    createdAt?: string
    uid: string
    image?: string
    title: string
    size?: Size
}
const UserInfoHeader: NextPage<Props> = ({ createdAt, image, uid, title, size }) => {
    const myUid = useAppSelector(
        (state) => state.userReducer?.user?.uid
    )
    const router = useRouter()
    const goToProfile = (uid: string) => {
        if (myUid !== uid)
            router.push('./profile?uid=' + uid)
        else
            router.push("./myProfile")
    }

    return (
        <div className={styles.name_image_section} >
            <img onClick={() => goToProfile(uid)} src={image || "/emptyProfile.png"} className={size === Size.small ? styles.image__small : styles.image} />
            <ColumnComponent>
                <div className={styles.poster}>{title}</div>
                {createdAt && (
                    <div className={styles.time} onClick={() => { }}>
                        {timeAgo(new Date(parseInt(createdAt)))}
                    </div>
                )}
            </ColumnComponent>
        </div>

    )
}

export default UserInfoHeader
